import React, { useState, useEffect } from 'react';

const BlockedIp = ({ ip }) => {
  const [progress, setProgress] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Animate progress bar to 70%
    const timer = setTimeout(() => setProgress(70), 500);
    return () => clearTimeout(timer);
  }, []);

  const bgImage = 'https://images.unsplash.com/photo-1614517453351-6c1522fc7a56?w=1920&q=80&auto=format&fit=crop';
  const sideImage1 = 'https://images.unsplash.com/photo-1448964899744-8929e9d992d7?w=600&q=80&auto=format&fit=crop';
  const sideImage2 = 'https://images.unsplash.com/photo-1614517453351-6c1522fc7a56?w=600&q=80&auto=format&fit=crop';
  const sideImage3 = 'https://images.unsplash.com/photo-1542317803-0fc679478393?w=600&q=80&auto=format&fit=crop';

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(135deg, rgba(0,0,0,0.75) 0%, rgba(10,25,60,0.7) 50%, rgba(0,0,0,0.8) 100%), url("${bgImage}") center/cover no-repeat fixed`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Tajawal', 'Cairo', 'Segoe UI', sans-serif",
      direction: 'rtl',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Decorative top bar with Palestine flag colors */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '6px',
        background: 'linear-gradient(to left, #000000 25%, #ffffff 25%, #ffffff 50%, #1a3366 50%, #1a3366 75%, #CE1126 75%)',
      }} />

      {/* Main content card */}
      <div style={{
        background: 'rgba(255,255,255,0.07)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: '24px',
        padding: '50px 40px',
        maxWidth: '700px',
        width: '100%',
        textAlign: 'center',
        border: '1px solid rgba(255,255,255,0.15)',
        boxShadow: '0 25px 60px rgba(0,0,0,0.5)',
        position: 'relative',
        zIndex: 2,
      }}>
        {/* Icon / Logo area */}
        <div style={{
          width: '90px',
          height: '90px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #0d2b5c, #1a3f7a)',
          margin: '0 auto 25px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 8px 30px rgba(13,43,92,0.4)',
        }}>
          <svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <path d="M21 15l-5-5L5 21" />
          </svg>
        </div>

        {/* Title */}
        <h1 style={{
          color: '#ffffff',
          fontSize: '2.4rem',
          fontWeight: '800',
          marginBottom: '8px',
          textShadow: '0 2px 10px rgba(0,0,0,0.3)',
          letterSpacing: '1px',
        }}>
          أرشيف الصور الفلسطيني
        </h1>

        <div style={{
          color: '#CE1126',
          fontSize: '1.1rem',
          fontWeight: '600',
          marginBottom: '30px',
          textTransform: 'uppercase',
          letterSpacing: '3px',
        }}>
          PALESTINIAN PHOTO ARCHIVE
        </div>

        {/* Coming Soon badge */}
        <div style={{
          display: 'inline-block',
          background: 'linear-gradient(135deg, #CE1126, #ff3b4e)',
          color: '#fff',
          padding: '10px 35px',
          borderRadius: '50px',
          fontSize: '1.3rem',
          fontWeight: '700',
          marginBottom: '35px',
          boxShadow: '0 6px 20px rgba(206,17,38,0.4)',
          animation: 'pulse 2s ease-in-out infinite',
        }}>
          🚀 قريباً
        </div>

        {/* Description */}
        <p style={{
          color: 'rgba(255,255,255,0.8)',
          fontSize: '1.05rem',
          lineHeight: '1.9',
          marginBottom: '35px',
          maxWidth: '550px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}>
          نعمل على بناء أكبر أرشيف رقمي للصور الفلسطينية التاريخية والمعاصرة.
          <br />
          منصة توثيقية شاملة تحفظ الذاكرة البصرية الفلسطينية للأجيال القادمة.
        </p>

        {/* Progress section */}
        <div style={{ marginBottom: '15px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '10px',
            padding: '0 5px',
          }}>
            <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>نسبة الإنجاز</span>
            <span style={{ color: '#5b9bd5', fontSize: '1.2rem', fontWeight: '700' }}>{progress}%</span>
          </div>
          <div style={{
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '12px',
            height: '14px',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.1)',
          }}>
            <div style={{
              width: `${progress}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #0d2b5c, #1a4f8a, #5b9bd5)',
              borderRadius: '12px',
              transition: 'width 2s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 0 20px rgba(26,79,138,0.4)',
              position: 'relative',
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                animation: 'shimmer 2s infinite',
              }} />
            </div>
          </div>
        </div>

        {/* Stats */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '40px',
          marginTop: '30px',
          flexWrap: 'wrap',
        }}>
          {[
            { num: '+10,000', label: 'صورة مؤرشفة' },
            { num: '+500', label: 'مجموعة تاريخية' },
            { num: '+50', label: 'مصدر موثّق' },
          ].map((stat, i) => (
            <div key={i} style={{ textAlign: 'center' }}>
              <div style={{ color: '#5b9bd5', fontSize: '1.5rem', fontWeight: '800' }}>{stat.num}</div>
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', marginTop: '4px' }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Image gallery preview */}
      <div style={{
        display: 'flex',
        gap: '16px',
        marginTop: '40px',
        maxWidth: '700px',
        width: '100%',
        justifyContent: 'center',
        flexWrap: 'wrap',
        position: 'relative',
        zIndex: 2,
      }}>
        {[sideImage1, sideImage2, sideImage3].map((img, i) => (
          <div key={i} style={{
            width: '200px',
            height: '130px',
            borderRadius: '16px',
            overflow: 'hidden',
            border: '2px solid rgba(255,255,255,0.15)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
            position: 'relative',
          }}>
            <img 
              src={img} 
              alt={`فلسطين ${i + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                filter: 'brightness(0.7) saturate(1.2)',
                transition: 'transform 0.4s ease',
              }}
              onMouseOver={e => e.target.style.transform = 'scale(1.1)'}
              onMouseOut={e => e.target.style.transform = 'scale(1)'}
              loading="lazy"
            />
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '40%',
              background: 'linear-gradient(transparent, rgba(0,0,0,0.6))',
            }} />
          </div>
        ))}
      </div>

      {/* Footer */}
      <div style={{
        marginTop: '40px',
        textAlign: 'center',
        position: 'relative',
        zIndex: 2,
      }}>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem' }}>
          © {new Date().getFullYear()} أرشيف الصور الفلسطيني — جميع الحقوق محفوظة
        </p>
      </div>

      {/* CSS Animations */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800;900&display=swap');
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default BlockedIp;
